import { IStateSliceDefaults, StateSliceName } from '../store.models';

import { IRosterStateModel } from './roster.models';

export const rosterStateDefaults: IStateSliceDefaults<IRosterStateModel> = Object.freeze({
    sliceName: StateSliceName.ROSTER,
    defaults: {
        roster: undefined
    }
});
